import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/schools";

class SchoolService {
  fetchSchools = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { schools } = response.data.data;
      return schools;
    } catch (err) {
      throw handleError(err, "Error occured while fetching schools.");
    }
  };

  fetchSchool = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { school } = response.data.data;
      return school;
    } catch (err) {
      throw handleError(err, "Error occured while fetching schools.");
    }
  };

  editSchool = async (data) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/me`, data);
      if (response.status !== 200) {
        throw new Error();
      }
      const { school } = response.data.data;
      return school;
    } catch (err) {
      throw handleError(err, "Error occured while fetching schools.");
    }
  };
}

export default new SchoolService();
